import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="public-nav" (the public sticky header).
// Toggles the mobile dropdown menu; the menu closes when a link inside it is
// clicked (data-action="public-nav#close") and on any click outside the header.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    document.addEventListener("click", this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
  }

  toggle(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
